import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Movies from "./common/movies";
import "bootstrap/dist/css/bootstrap.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Movies />
  </React.StrictMode>
);

reportWebVitals();
